import React from 'react';
import { IonIcon } from '@ionic/react';
import { chevronForward } from 'ionicons/icons';

interface GolfClub {
  id: number;
  type: string;
  brandName?: string;
  modelName?: string;
  customModelName?: string;
  clubNumber?: number;
  loft?: number;
  inBag: boolean;
  shaftFlex?: 'regular' | 'stiff' | 'extra-stiff' | 'senior' | 'ladies' | 'stiff/regular' | string;
  performance?: {
    averageDistance?: number;
  };
}

interface GearCardProps {
  club: GolfClub;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  showDistance?: boolean;
}

export const GearCard: React.FC<GearCardProps> = ({ club, onClick, showDistance = true }) => {
  const getClubName = () => {
    if (club.type === 'driver') {
      return 'Driver';
    } else if (club.type === 'putter') {
      return 'Putter';
    } else if (club.type === 'wedge' && club.loft) {
      return `${club.loft}° Wedge`;
    } else if (club.type === 'wedge') {
      const wedgeTypes: Record<number, string> = {
        0: 'Pitching Wedge',
        1: 'Gap Wedge',
        2: 'Sand Wedge',
        3: 'Lob Wedge',
      };
      return wedgeTypes[club.clubNumber || 0] || 'Wedge';
    } else {
      return `${club.clubNumber} ${club.type.charAt(0).toUpperCase() + club.type.slice(1)}`;
    }
  };

  const getBrandModel = () => {
    const brand = club.brandName || '';
    const model = club.customModelName || club.modelName || '';

    if (brand && model) {
      return `${brand} ${model}`;
    } else if (brand) {
      return brand;
    } else if (model) {
      return model;
    }

    return '';
  };

  const getClubLabel = () => {
    if (club.type === 'driver') {
      return 'DR';
    } else if (club.type === 'wood') {
      return `${club.clubNumber}W`;
    } else if (club.type === 'hybrid') {
      return `${club.clubNumber}H`;
    } else if (club.type === 'iron') {
      return `${club.clubNumber}`;
    } else if (club.type === 'wedge') {
      return club.loft ? `${club.loft}°` : 'W';
    } else if (club.type === 'putter') {
      return 'PT';
    }
    return '';
  };

  return (
    <div
      className="relative overflow-hidden rounded-lg border bg-card p-4 shadow-sm cursor-pointer ion-activatable md:size-64"
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="flex items-center justify-center size-14 bg-secondary rounded-lg">
            <span className="text-sm font-bold">
              {getClubLabel()}
            </span>
          </div>
          <div>
            <h3 className="font-medium">{getClubName()}</h3>
            {getBrandModel() && (
              <p className="text-sm">{getBrandModel()}</p>
            )}
            {club.shaftFlex && club.type !== 'putter' && (
              <p className="text-xs text-muted-foreground mt-1">
                Shaft: <span className="font-semibold capitalize">{club.shaftFlex}</span>
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center">
          {showDistance && club.performance?.averageDistance && (
            <div className="text-right mr-2">
              <span className="text-lg font-bold">{club.performance.averageDistance}</span>
              <span className="text-xs text-muted-foreground ml-1">m</span>
            </div>
          )}
          <IonIcon icon={chevronForward} className="text-muted-foreground" />
        </div>
      </div>
    </div>
  );
};

